/**
 * "Another company subcontracting work to us" and, when ticked, the rates that
 * company is billed at (D86). A blank rate falls back to the business's, and
 * says what that is. Controlled by the customer form that holds it.
 */
import { useQuery } from "@tanstack/react-query";

import { api } from "../lib/api";
import { money } from "../lib/format";
import { type ContractorText, usesPlaceholder } from "../lib/servicerates";

export function ContractorRates({
  isContractor,
  text,
  onToggle,
  onChange,
}: {
  isContractor: boolean;
  text: ContractorText;
  onToggle: (on: boolean) => void;
  onChange: (key: keyof ContractorText, value: string) => void;
}) {
  const org = useQuery({ queryKey: ["org"], queryFn: () => api.org.get(), staleTime: 10_000 });
  const fields: { key: keyof ContractorText; label: string; business: number | undefined }[] = [
    { key: "fee", label: "Service call fee ($)", business: org.data?.service_call_fee_cents },
    { key: "hourly", label: "Hourly rate ($)", business: org.data?.service_hourly_rate_cents },
    { key: "km", label: "Km rate ($/km)", business: org.data?.service_km_rate_cents },
  ];
  return (
    <>
      <label className="check-row">
        <input type="checkbox" checked={isContractor} onChange={(e) => onToggle(e.target.checked)} />
        <span>
          Contractor
          <small className="tiny muted" style={{ display: "block" }}>
            Another company subcontracting work to us
          </small>
        </span>
      </label>
      {isContractor && (
        <div className="stack">
          {fields.map((f) => (
            <label key={f.key} className="field">
              <span>{f.label} — optional</span>
              <input
                inputMode="decimal"
                value={text[f.key]}
                placeholder={usesPlaceholder(f.business, money)}
                onChange={(e) => onChange(f.key, e.target.value)}
              />
            </label>
          ))}
        </div>
      )}
    </>
  );
}
